define([
	"dojo/_base/declare",
	"csi/_base/underscore",
	"csi/core/extendedPathService",
	"csi/xml",
	"csi/heading/Expression"
], function(declare, _, {parsePathSteps}, xml, Expression) {

	return declare(Expression, {
		_getValue: function(/*Context*/ctx, /*Heading*/h) {
			// summary: count number of nodes that will be queried based on paths and page size
			var paths = ctx.view._getViewPaths(ctx);
			var obj = {};

			_.each(paths, function(path) {
				var steps = parsePathSteps(path);
				var p;

				_.each(steps, function(step) {
					p = xml.path(p, step.a);
					obj[p] = 1;
				});
			});

			return _.size(obj);
		}
	});
});